export interface PlanOption {
  id: string;
  paymentPlanId?: number;
  title: string;
  description: string;
  price: string;
  oldPrice?: string;
}

export interface SubscriptionCard {
  id: string;
  name: string;
  cardDescription: string;
  advantages: string[];
  highlighted?: boolean;
  plans: PlanOption[];
}

export enum TabId {
  Monthly = "monthly",
  Quarterly = "quarterly",
  Yearly = "yearly",
}

export const basicPlanIds = [2, 5, 8];

export const modifiedMonthlyPremium: PlanOption[] = [
  {
    id: "premium-1",
    paymentPlanId: 4,
    title: "10 унікальних IBAN",
    description: "3 000  платіжних посилань",
    price: "499",
  },
  {
    id: "premium-2",
    paymentPlanId: 11,
    title: "20 унікальних IBAN",
    description: "6 000  платіжних посилань",
    price: "998",
  },
  {
    id: "premium-3",
    paymentPlanId: 12,
    title: "50 унікальних IBAN",
    description: "15 000  платіжних посилань",
    price: "2495",
  },
  {
    id: "custom",
    title: "Cвій ліміт унікальних IBAN",
    description: "Cвій ліміт платіжних посилань",
    price: "",
  },
];

export const modifiedYearlyPremium: PlanOption[] = [
  {
    id: "premium-yearly-1",
    paymentPlanId: 10,
    title: "10 унікальних IBAN",
    description: "3 000  платіжних посилань",
    oldPrice: "5988",
    price: "4990",
  },
  {
    id: "premium-yearly-2",
    paymentPlanId: 13,
    title: "20 унікальних IBAN",
    description: "6 000  платіжних посилань",
    oldPrice: "11976",
    price: "9980",
  },
  {
    id: "premium-yearly-3",
    paymentPlanId: 14,
    title: "50 унікальних IBAN",
    description: "15 000  платіжних посилань",
    oldPrice: "29940",
    price: "24950",
  },
  {
    id: "custom",
    title: "Cвій ліміт унікальних IBAN",
    description: "Cвій ліміт платіжних посилань",
    price: "",
  },
];

export const monthlySubscriptions: SubscriptionCard[] = [
  {
    id: "free",
    name: "Безкоштовний",
    cardDescription: "Ідеально для перших оплат",
    advantages: ["1 унікальний IBAN;", "75 платіжних посилань."],
    plans: [
      {
        id: "free",
        paymentPlanId: 1,
        title: "Безкоштовний",
        description: "Ідеально для перших оплат",
        price: "0",
      },
    ],
  },
  {
    id: "basic",
    name: "Базовий",
    cardDescription: "Для впевненого старту",
    advantages: [
      "1 унікальний IBAN;",
      "300 платіжних посилань;",
      "Історія платіжних посилань;",
      "Обрані (улюблені) платежі;",
      "Нотатки до переказу;",
      "Платіжні посилання з фіксованою сумою.",
    ],
    plans: [
      {
        id: "basic",
        paymentPlanId: 2,
        title: "Базовий",
        description: "Для впевненого старту",
        price: "199",
      },
    ],
  },
  {
    id: "standard",
    name: "Стандарт",
    cardDescription: "Для бізнесу, що зростає",
    advantages: [
      "5 унікальних IBAN;",
      "1000 платіжних посилань;",
      "Історія платіжних посилань;",
      "Обрані (улюблені) платежі;",
      "Нотатки до переказу;",
      "Платіжні посилання з фіксованою сумою;",
      "Платіжні посилання з відкритою сумою;",
      "Шаблони реквізитів оплати;",
      "Фільтрація платежів;",
      "Термін дії платіжного посилання.",
    ],
    plans: [
      {
        id: "standard",
        paymentPlanId: 3,
        title: "Стандарт",
        description: "Для бізнесу, що зростає",
        price: "299",
      },
    ],
    highlighted: true,
  },
  {
    id: "premium",
    name: "Преміум",
    cardDescription: "Максимум можливостей",
    advantages: [
      "Історія платіжних посилань;",
      "Обрані (улюблені) платежі;",
      "Нотатки до переказу;",
      "Платіжні посилання з фіксованою сумою;",
      "Платіжні посилання з відкритою сумою;",
      "Шаблони реквізитів оплати;",
      "Фільтрація платежів;",
      "Термін дії платіжного посилання;",
      "API-інтеграція;",
      "Персональний консультант;",
      "Технічна підтримка.",
    ],
    plans: modifiedMonthlyPremium,
  },
];

export const quarterlySubscriptions = [
  {
    paymentPlanId: 7,
    id: "premium-quarterly",
    name: "Преміум квартальний",
    description: "Максимум функцій для професіоналів",
    price: "1379",
    advantages: [
      "до 10 різних рахунків для прийому IBAN оплат",
      "3000 платіжних посилань;",
      "Історія платіжних посилань;",
      "Шаблони реквізитів оплати;",
      "API інтеграція;",
      "Персональний консультант.",
    ],
  },
  {
    paymentPlanId: 6,
    id: "standard-quarterly",
    name: "Стандарт квартальний",
    description: "Оптимальний баланс можливостей",
    price: "829",
    advantages: [
      "до 5 різних рахунків для прийому IBAN оплат;",
      "1000 платіжних посилань;",
      "Історія платіжних посилань;",
      "Шаблони реквізитів оплати.",
    ],
    highlighted: true,
  },
  {
    paymentPlanId: 5,
    id: "basic-quarterly",
    name: "Базовий квартальний",
    description: "Стартуй легко та впевнено",
    price: "549",
    advantages: [
      "1 рахунок для прийому IBAN оплат;",
      "300 платіжних посилань;",
      "Історія платіжних посилань.",
    ],
  },
];

export const yearlySubscriptions: SubscriptionCard[] = [
  {
    id: "free-yearly",
    name: "Безкоштовний",
    cardDescription: "Ідеально для перших оплат",
    advantages: ["1 унікальний IBAN;", "75 платіжних посилань."],
    plans: [
      {
        id: "free-yearly",
        paymentPlanId: 1,
        title: "Безкоштовний",
        description: "Ідеально для перших оплат",
        price: "0",
      },
    ],
  },

  {
    id: "basic-yearly",
    name: "Базовий",
    cardDescription: "Для впевненого старту",
    advantages: [
      "1 унікальний IBAN;",
      "300 платіжних посилань;",
      "Історія платіжних посилань;",
      "Обрані (улюблені) платежі;",
      "Нотатки до переказу;",
      "Платіжні посилання з фіксованою сумою.",
    ],
    plans: [
      {
        id: "basic-yearly",
        paymentPlanId: 8,
        title: "Базовий",
        description: "Для впевненого старту",
        oldPrice: "2388",
        price: "1990",
      },
    ],
  },
  {
    id: "standard-yearly",
    name: "Стандарт",
    cardDescription: "Для бізнесу, що зростає",
    advantages: [
      "5 унікальних IBAN;",
      "1000 платіжних посилань;",
      "Історія платіжних посилань;",
      "Обрані (улюблені) платежі;",
      "Нотатки до переказу;",
      "Платіжні посилання з фіксованою сумою;",
      "Платіжні посилання з відкритою сумою;",
      "Шаблони реквізитів оплати;",
      "Фільтрація платежів;",
      "Термін дії платіжного посилання.",
    ],
    plans: [
      {
        id: "standard-yearly",
        paymentPlanId: 9,
        title: "Стандарт",
        description: "Для бізнесу, що зростає",
        oldPrice: "3588",
        price: "2990",
      },
    ],
    highlighted: true,
  },
  {
    id: "premium-yearly",
    name: "Преміум",
    cardDescription: "Максимум можливостей",
    advantages: [
      "Історія платіжних посилань;",
      "Обрані (улюблені) платежі;",
      "Нотатки до переказу;",
      "Платіжні посилання з фіксованою сумою;",
      "Платіжні посилання з відкритою сумою;",
      "Шаблони реквізитів оплати;",
      "Фільтрація платежів;",
      "Термін дії платіжного посилання;",
      "API-інтеграція;",
      "Персональний консультант;",
      "Технічна підтримка.",
    ],
    plans: modifiedYearlyPremium,
  },
];

export const subscriptionTabs = [
  {
    id: TabId.Monthly,
    label: "Щомісячний",
    subscriptions: monthlySubscriptions,
    period: "місяць",
  },
  // {
  //   id: "quarterly",
  //   label: "Квартальний",
  //   subscriptions: quarterlySubscriptions,
  //   description: "Хочете ще більше вигоди? Беріть річний!",
  //   period: "квартал",
  // },
  {
    id: TabId.Yearly,
    label: "Річний",
    subscriptions: yearlySubscriptions,
    period: "рік",
  },
];
